import camile from '../public/Pictures/camile.png'
import noelle from '../public/Pictures/noelle.png'
import katie from '../public/Pictures/katie.png'
import guillermo from '../public/Pictures/guillermo.png'
import chalfant from '../public/Pictures/josh-chalfant.png'
import paulina from '../public/Pictures/paulina-k.png'
import himmel from '../public/Pictures/himmel.png'
import oleg from '../public/Pictures/oleg.png'
import victoria from '../public/Pictures/victoria.png'
import carlossosa from '../public/Pictures/carlossosa.png'
import lenox from '../public/Pictures/lenox.png'
import kristen from '../public/Pictures/kristen.png'
import stamos from '../public/Pictures/stamos.png'
import erica from '../public/Pictures/erica.png'
import vant from '../public/Pictures/vant.png'
import singles from '../public/Pictures/singles.png'
 

module.exports = [
    {
        name: 'Kathy Stamos',
        date: 'Dec 27, 2023',
        picture: stamos,
        stars: 5,
        body:'It’s a pleasure to work with Mario and his team, they are quick, efficient, and professional. Have done a few events already and looking forward to many more',
        link:'https://g.co/kgs/emojvb',
        tags: ['convenient', 'empower', 'corporate']
    },
    {
        name: 'Stephanie Van Tieghem',
        date: 'Dec 4, 2023',
        picture: vant,
        stars: 5,
        body:'We used Miami Sound Rental for a conference we were sponsoring. They were the perfect choice for the role. Easy to work with and arrived on time. Quick and efficient. We had to change a few things the week before the event and they were able to accommodate our changes with no issue.',
        link:'https://g.co/kgs/SHLhw5',
   
        tags: ['convenient', 'corporate']
    },
    {
        name: 'Erica Jerome',
        date: 'Nov 2, 2023',
        picture: erica,
        stars: 5,
        body:'Delivered on time and showed us exactly how to use the equipment and picked it up the next morning! Was perfect for my birthday party and would definitely use them again!',
        link:'https://g.co/kgs/rdkBga',
  
        tags: ['trust','convenient', 'empower', 'party']
    },
    {
        name: 'Paulina Kucharska',
        date: 'August 14, 2023',
        picture: paulina,
        stars: 5,
        body:'I Love this company. Professional, helpful, diligent and extremely punctual! Kate is the best - make sure you speak with her because she will Make it Happen! I highly recommend this company.',
        link:'https://g.co/kgs/Vkck29',
        tags: ['trust','convenient']
    },
    {
        name: 'Paul Himmel',
        date: 'August 28, 2023',
        picture: himmel,
        stars: 5,
        body:'Called Mario Saturday afternoon, hot speakers delivered Saturday night!  Reliable, clean, on point!',
        link:'https://g.co/kgs/97oUct',
        tags: ['convenient', 'party', 'speaker']
    },
    {
        name: 'Josh Chalfant',
        date: 'July 8, 2023',
        picture: chalfant,
        stars: 5,
        body:'Miami Sound Rental saved the weekend for me! I was in a bind when I arrived in Miami, as I needed sound equipment (last minute) for a 100+ attendee private event in Key Largo on Sat 7/8. I called and spoke to Kate, and she was AMAZING!! I’m not a very tech savvy guy, but she talked through all of their options and they had everything I needed for my event. I showed up and they had all of the equipment ready for me. I will absolutely rent from them again when I’m in South Florida! Thank you, Kate and team!',
        link:'https://g.co/kgs/vDxwgm',
        tags: ['convenient', 'party', 'speaker']
    },
    {
        name: 'Christie Lenox',
        date: 'May 30, 2023',
        picture: lenox,
        stars: 5,
        body:'Miami Sound Rental was excellent to work with!  They made everything so easy from start to finish.   The team was great to work with.  I would highly recommend them to anyone looking for an AV vendor.',
        link:'https://g.co/kgs/MgH4NQ',
   
        tags: ['trust','convenient']
    },
    {
        name: 'Guillermo Balseca',
        date: 'March 5, 2023',
        picture: guillermo,
        stars: 5,
        body:'Miami Sound Rental is top notch. I am a Project Manager based out of New Jersey. Planning an event in Miami seemed a little overwhelming at first until I got in Contact with Alex from Miami Sound Rental. He was very professional and knowledgeable of everything I was expecting. I will definitely use Miami Sound Rental again in the future and will recommend to any Producers needing planning done in Miami or anywhere in South Florida. Thank you for being part of making our event a great success.',
        link:'https://g.co/kgs/6kseGU',
        tags: ['trust','convenient', 'corporate']
    },
    {
        name: 'Katie Sebastiano',
        date: 'Feb 12, 2023',
        picture: katie,
        stars: 5,
        body:'Everything was very easy. They were here on time, they always had great communication with me and explained everything and answered all my questions right away. Their equipment was really nice and new and worked perfectly.',
        link:'https://g.co/kgs/ReJyij',
        tags: ['convenient', 'empower', 'party']
    },
    {
        name: 'Victoria Sepulveda',
        date: 'Feb 4, 2023',
        picture: victoria,
        stars: 5,
        body:'Absolutely amazing service and professionalism. Delivery, set up and pick absolutely perfect. Thanks',
        link:'https://g.co/kgs/o5whRM',
        tags: ['trust']
    },
    {
        name: 'Oleg Safronov',
        date: 'Dec 22, 2022',
        picture: oleg,
        stars: 5,
        body:`Outstanding service! Attentiveness to the smallest customer's details. Instant communications. Huge huge kudos to Mario and Pedro!`,
        link:'https://g.co/kgs/YTp3aG',
        tags: ['trust','convenient']
    },
    {
        name: 'Noelle Vander Hoff',
        date: 'Dec 4, 2022',
        picture: noelle,
        stars: 5,
        body:`Pedro and his team are INCREDIBLE! We needed a last minute AV and Lighting crew for an event on a boat and he jumped right into the opportunity. They were extremely responsive the whole process. Not having a ton of experience with production, they were able to provide knowledge on how set up works, what products we would need to suit our event, and I didn’t feel like we were overcharged or scammed. Their whole team was kind, willing to roll with the punches and were hard workers throughout the whole event. Can’t speak highly enough of them.
    
        I would HIGHLY recommend Miami Sound Rental for any of your events.`,
        link:'https://g.co/kgs/JDQzUk',
        tags: ['trust','convenient', 'empower', 'party', 'speaker']
    },
    {
        name: 'Carlos Sosa',
        date: 'Nov 28, 2022',
        picture: carlossosa,
        stars: 5,
        body:`The attention to detail by everyone involved in my event was a pleasant surprise. The delivery and pick up timely to the minute. Also the equipment I rented looked new and of high quality. I will undoubtedly  keep doing business with you.`,
        link:'https://g.co/kgs/eWFLmc',
        tags: ['trust','convenient']
    },
    {
        name: 'Kristen Smith',
        date: 'Nov 12, 2022',
        picture: kristen,
        stars: 5,
        body:`Absolutely amazing to work with! Kate and the AV team did a fantastic job working our corporate retreat for 3 days. Working with them was the smoothest part of planning the whole retreat. I cannot recommend them highly enough. They’re knowledgeable, affordable, and incredibly efficient. Justin is a great AV tech. Lao — he’s THE MAN! Do yourself a favor and make your event painless. Call Kate and let her help solve your AV problems. Thanks again!`,
        link:'https://g.co/kgs/BhFda3',
        tags: ['trust','convenient', 'empower', 'corporate']
    },
    {
        name: 'Camille Jules',
        date: 'Oct 24, 2022',
        picture: camile,
        stars: 5,
        body:'Such amazing customer service I am beyond satisfied with this company. Mario was very prompt, professional, and also very kind. From the first call consultation until the day of the event, I felt at ease. The set up was amazing and the equipment all worked so great! Thank you for helping to make my event setup a smooth one! Can’t wait to book again! I highly highly highly recommend this company.',
        link:'https://goo.gl/maps/2P2mfSDA2z6Qw8WH9',
        tags: ['trust','convenient']
    },
    {
        name: 'Caitlin Singles',
        date: 'Oct 21, 2022',
        picture: singles,
        stars: 5,
        body:'We hosted a seminar and rented a projector and some microphones from Miami Sound Rental. We had a great experience and will likely use them again for future seminars.',
        link:'https://g.co/kgs/qmbwfF',
        tags: ['trust','convenient', 'empower', 'corporate', 'microphone', 'projector']
    },


]
